import { ArrowForwardIos, ArrowBackIos } from '@mui/icons-material';

export const PrevNextNavigation = ({ prev, next }) => {
	return <div className="bbt-navigation my-5 flex justify-between" >
		{prev ?
			<a href={prev.permalink}><ArrowBackIos />{ prev.title }</a> : <div></div>}
		{ next && <a href={next.permalink}>{ next.title }<ArrowForwardIos /></a> }
	</div>;
};
